export default __webpack_public_path__ + "static/media/IconInfo.95a4ae74.png";